export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_property-operator/artifacts/d87yvdyy_Adaptar%20logo%20The%20Next%20Room.png";

// Interiores reales, reformados y acogedores — sin chalets ni viviendas premium.
// Salones con sofá y TV, dormitorios bien decorados, pisos urbanos normales.
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1600&q=80";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1400&q=80";

// Casos reales — 3 habitaciones / salones reformados, sin estética de lujo.
export const CASE_IMAGES = [
  "https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1502672023488-70e25813eb80?auto=format&fit=crop&w=1200&q=80",
];

export const PROBLEM_IMAGE =
  "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1400&q=80";

export const AGENCY_IMAGE =
  "https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=1400&q=80";

export const OWNER_IMAGE =
  "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1400&q=80";
